import { useTranslation } from 'next-i18next'

import * as styles from './product-info-price-ds.styles'

// Third-party "Best market value" message; two call sites (festival / no-festival) render identical markup.
function BestMarketValue() {
  const { t } = useTranslation('common')
  return <div className={styles.priceWrapperMainThirdPartyMsgCss}>{t('best_market_value')}</div>
}

export default BestMarketValue
